const SET_MY_LISTS = 'SET_MY_LISTS';
const GET_MY_LISTS_INITIAL_DATA = 'GET_MY_LISTS_INITIAL_DATA';
const SET_MY_CUSTOM_LIST = 'SET_MY_CUSTOM_LIST';
const UPDATE_MY_CUSTOM_LIST = 'UPDATE_MY_CUSTOM_LIST';
const UPDATE_LIST_CATEGORIES = 'UPDATE_LIST_CATEGORIES';

export {
    SET_MY_LISTS, GET_MY_LISTS_INITIAL_DATA, SET_MY_CUSTOM_LIST, UPDATE_MY_CUSTOM_LIST, UPDATE_LIST_CATEGORIES
};
